import React, { Component, createContext } from "react";

/**
 * WidgetEventContext - React Context event bus for cross-widget communication.
 * Full implementation in Phase 5.
 *
 * Usage:
 *   <WidgetEventProvider>
 *     <WidgetRenderer ... />
 *   </WidgetEventProvider>
 */

const WidgetEventContext = createContext({
  emit: () => {},
  subscribe: () => {},
  unsubscribe: () => {},
});

export class WidgetEventProvider extends Component {
  constructor(props) {
    super(props);
    this.subscribers = {};
  }

  emit = (eventName, sourceWidgetId, data) => {
    const key = eventName;
    if (this.subscribers[key]) {
      this.subscribers[key].forEach((cb) => {
        try {
          cb({ eventName, sourceWidgetId, data });
        } catch (e) {
          console.error("Widget event handler error:", e);
        }
      });
    }
  };

  subscribe = (eventName, widgetId, callback) => {
    const key = eventName;
    if (!this.subscribers[key]) {
      this.subscribers[key] = [];
    }
    this.subscribers[key].push(callback);
  };

  unsubscribe = (eventName, widgetId) => {
    const key = eventName;
    if (this.subscribers[key]) {
      // Remove all callbacks for this widget (simple approach - full impl in Phase 5)
      delete this.subscribers[key];
    }
  };

  render() {
    return (
      <WidgetEventContext.Provider
        value={{
          emit: this.emit,
          subscribe: this.subscribe,
          unsubscribe: this.unsubscribe,
        }}
      >
        {this.props.children}
      </WidgetEventContext.Provider>
    );
  }
}

export default WidgetEventContext;
